/**
 * useRules.js
 *
 * Hook für Zugriff auf das zentrale Rules-Objekt.
 * Gibt immer ein gültiges Objekt zurück (nie null) — Fallback ist rulesFallback.
 *
 * Verwendung:
 *   const rules = useRules();
 *   const color = rules.color_tokens['verdict-green'];
 */

import { useContext } from 'react';
import { RulesContext } from '../contexts/RulesContext';

export function useRules() {
  return useContext(RulesContext);
}
